import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_5 = { class: "row mx-0" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = {
  class: "col-6",
  style: {"padding-top":"48px"}
}
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "p-field-label" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "row mx-0" }
const _hoisted_16 = {
  class: "col-6",
  style: {"padding-top":"40px"}
}
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "bt-icon bt-icon--xs" }
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ToggleSwitchButton = _resolveComponent("ToggleSwitchButton")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_CallModeForm = _resolveComponent("CallModeForm")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogImportFile = _resolveComponent("DialogImportFile")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.SetupThePlant")), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.SystemParameters")), 1),
                _createVNode("div", _hoisted_8, [
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResourceEP.DeviceLanguage")), 1),
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.infoPlant.language,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.infoPlant.language = $event)),
                    options: _ctx.validLanguages,
                    optionLabel: "name",
                    optionValue: "code",
                    class: "w-100"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResourceEP.Switchboard")), 1),
                      _createVNode("div", _hoisted_14, [
                        _createVNode("small", null, _toDisplayString(_ctx.$t(
                                                    "AppResourceEP.InsertASwitchboardAtPlantCreation"
                                                )), 1)
                      ])
                    ]),
                    _createVNode(_component_ToggleSwitchButton, {
                      class: "ml-auto",
                      modelValue: _ctx.switchboardActive,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchboardActive = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("AppResourceEP.CallMode")), 1),
                  (!_ctx.isBRFA)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-rounded ml-auto p-button-outlined",
                        style: {"max-height":"24px !important"},
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.triggerFilePicker()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode("input", {
                            type: "file",
                            id: "fileInput",
                            style: {"display":"none"},
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                            accept: ".csv"
                          }, null, 32),
                          _createVNode("span", _hoisted_19, [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                            require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                                        ,
                              "aria-label": "icon-alert"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("general.import")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_component_CallModeForm, {
              class: "mt-4",
              ref: "callModeForm",
              infoPlant: _ctx.infoPlant
            }, null, 8, ["infoPlant"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("footer", _hoisted_21, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "label"])
    ]),
    _createVNode(_component_DialogImportFile, {
      entrancePlantDetail: _ctx.infoPlant,
      importedData: _ctx.importedData,
      isVisible: _ctx.isVisibleDialogImportFile,
      onHideDialog: _ctx.handleCloseDialog,
      onOverwrite: _ctx.overwrite,
      isCreationMode: true,
      onUpdatePlant: _ctx.handleUpdatePlant,
      onGrouped: _ctx.handleGrouped
    }, null, 8, ["entrancePlantDetail", "importedData", "isVisible", "onHideDialog", "onOverwrite", "onUpdatePlant", "onGrouped"])
  ], 64))
}